import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { printThermalViaUSB } from '@/utils/thermalPrinter';

export const printReceipt = (element, format = 'a4') => {
  if (!element) return;
  try {
    const settings = JSON.parse(localStorage.getItem('gymAppSettings') || '{}');
    if (format === 'thermal' && settings?.thermalPrinter?.mode === 'usb' && settings?.thermalPrinter?.paired) {
      printThermalViaUSB(element);
      return;
    }
  } catch {}
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;
  let printContent = '';
  if (format === 'thermal') {
    const node = element.querySelector('.receipt-thermal');
    printContent = node ? node.innerHTML : element.innerHTML;
  } else if (format === 'a5') {
    const node = element.querySelector('.receipt-a5');
    const fallback = element.querySelector('.receipt-a4');
    printContent = node ? node.innerHTML : (fallback ? fallback.innerHTML : element.innerHTML);
  } else {
    const node = element.querySelector('.receipt-a4');
    printContent = node ? node.innerHTML : element.innerHTML;
  }
  
  printWindow.document.write(`
    <html>
      <head>
        <title>Print Receipt</title>
        <style>
          @media print {
            @page {
              ${format === 'a5' ? 'size: A5;' : format === 'thermal' ? 'size: 80mm 200mm;' : 'size: A4;'}
              margin: ${format === 'thermal' ? '0' : '10mm'};
            }
            body {
              margin: 0;
              padding: 0;
            }
          }
          body {
            font-family: Arial, sans-serif;
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
  `);
  
  printWindow.document.close();
  
  setTimeout(() => {
    printWindow.print();
  }, 250);
};

export const downloadReceiptPDF = async (element, filename = 'receipt.pdf', format = 'a4') => {
  if (!element) return;
  
  const receiptElement = format === 'thermal'
    ? element.querySelector('.receipt-thermal')
    : (format === 'a5'
        ? (element.querySelector('.receipt-a5') || element.querySelector('.receipt-a4'))
        : element.querySelector('.receipt-a4'));
  
  if (!receiptElement) return;
  
  try {
    const prev = {
      display: receiptElement.style.display,
      visibility: receiptElement.style.visibility,
      position: receiptElement.style.position,
      left: receiptElement.style.left,
      top: receiptElement.style.top,
    };
    receiptElement.style.display = 'block';
    receiptElement.style.visibility = 'hidden';
    receiptElement.style.position = 'fixed';
    receiptElement.style.left = '-9999px';
    receiptElement.style.top = '0';

    // Create canvas from HTML
    const canvas = await html2canvas(receiptElement, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      foreignObjectRendering: true,
      logging: false,
      backgroundColor: '#ffffff'
    });
    receiptElement.style.display = prev.display;
    receiptElement.style.visibility = prev.visibility;
    receiptElement.style.position = prev.position;
    receiptElement.style.left = prev.left;
    receiptElement.style.top = prev.top;
    
    const imgData = canvas.toDataURL('image/png');
    
    // Create PDF
    let pdf;
    if (format === 'a5') {
      pdf = new jsPDF('p', 'mm', 'a5');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    } else if (format === 'thermal') {
      pdf = new jsPDF('p', 'mm', [80, 200]);
      const pdfWidth = 80;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    } else {
      // A4
      pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    }
    
    pdf.save(filename);
    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    return false;
  }
};

export const shareReceiptPDF = async (element, filename = 'receipt.pdf', format = 'a4') => {
  if (!element) return;
  
  const receiptElement = format === 'thermal'
    ? element.querySelector('.receipt-thermal')
    : (format === 'a5'
        ? (element.querySelector('.receipt-a5') || element.querySelector('.receipt-a4'))
        : element.querySelector('.receipt-a4'));
  
  if (!receiptElement) return;
  
  try {
    const prev = {
      display: receiptElement.style.display,
      visibility: receiptElement.style.visibility,
      position: receiptElement.style.position,
      left: receiptElement.style.left,
      top: receiptElement.style.top,
    };
    receiptElement.style.display = 'block';
    receiptElement.style.visibility = 'hidden';
    receiptElement.style.position = 'fixed';
    receiptElement.style.left = '-9999px';
    receiptElement.style.top = '0';

    // Create canvas from HTML
    const canvas = await html2canvas(receiptElement, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      foreignObjectRendering: true,
      logging: false,
      backgroundColor: '#ffffff'
    });
    receiptElement.style.display = prev.display;
    receiptElement.style.visibility = prev.visibility;
    receiptElement.style.position = prev.position;
    receiptElement.style.left = prev.left;
    receiptElement.style.top = prev.top;
    
    const imgData = canvas.toDataURL('image/png');
    
    // Create PDF blob
    let pdf;
    if (format === 'a5') {
      pdf = new jsPDF('p', 'mm', 'a5');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    } else if (format === 'thermal') {
      pdf = new jsPDF('p', 'mm', [80, 200]);
      const pdfWidth = 80;
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    } else {
      pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    }
    
    const pdfBlob = pdf.output('blob');
    
    // Check if Web Share API is supported
    if (navigator.share && navigator.canShare) {
      const file = new File([pdfBlob], filename, { type: 'application/pdf' });
      
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file],
          title: 'Receipt',
          text: 'Payment Receipt'
        });
        return true;
      }
    }
    
    // Fallback: Download the PDF
    pdf.save(filename);
    return true;
  } catch (error) {
    console.error('Error sharing PDF:', error);
    return false;
  }
};

export const numberToWords = (num) => {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  
  if (num === 0) return 'Zero';
  
  const convertLessThanThousand = (n) => {
    if (n === 0) return '';
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + convertLessThanThousand(n % 100) : '');
  };
  
  const convertToWords = (n) => {
    if (n === 0) return 'Zero';
    
    let words = '';
    
    if (n >= 10000000) {
      words += convertLessThanThousand(Math.floor(n / 10000000)) + ' Crore ';
      n %= 10000000;
    }
    
    if (n >= 100000) {
      words += convertLessThanThousand(Math.floor(n / 100000)) + ' Lakh ';
      n %= 100000;
    }
    
    if (n >= 1000) {
      words += convertLessThanThousand(Math.floor(n / 1000)) + ' Thousand ';
      n %= 1000;
    }
    
    if (n > 0) {
      words += convertLessThanThousand(n);
    }
    
    return words.trim();
  };
  
  const intPart = Math.floor(num);
  const decimalPart = Math.round((num - intPart) * 100);
  
  let result = convertToWords(intPart) + ' Rupees';
  
  if (decimalPart > 0) {
    result += ' and ' + convertToWords(decimalPart) + ' Paise';
  }
  
  return result + ' Only';
};
